import { React, useState, useEffect }  from "react"
import { Link } from "react-router-dom"
import "./Jobs.css"
import axios from "../../api/axios"
import _ from 'lodash';

const Jobs = () => {
    const [allJobs, setAllJobs] = useState();
    const[jobs, setJobs] = useState();

    const getJobInfo = async () => {
        try {
            const response = await axios.get('/listings');
            const data = response.data;

            

            setJobs(_.orderBy(data, ['role']));
            setAllJobs(_.orderBy(data, ['role']));
        } catch(err) {
            console.log(err);
        }   
    }

    useEffect(() => {
        getJobInfo();

    }, []);

    const [filterArray] = useState([]);

    const[locations] = useState(['El Dorado Hills', 'Granite Bay', 'Lincoln', 'Sacramento', 'Victorville']);
    const[departments] = useState(['Sales', 'Field', 'Office', 'Marketing', 'Accounting', 'Customer Service', 'Programming']);

    function filterJobs(value) {
        if(filterArray.includes(value)){
            const index = filterArray.indexOf(value);
            filterArray.splice(index, 1);
        } else {
            filterArray.push(value);
        }

        if(filterArray.length === 0){
            setJobs(allJobs);
        } else {
            let temp = [];

            filterArray.forEach(value => {
                const filterForEach = allJobs.filter(job => {
                    return job.location.includes(value) || job.department.includes(value);
                });
                
                temp = temp.concat(filterForEach);
            });

            const filtered = temp.filter((value, index) => {
                const _value = JSON.stringify(value);
                return index === temp.findIndex(obj => {
                  return JSON.stringify(obj) === _value;
                });
            });

            setJobs(filtered);
        }
    };

    return(
        <div className="wrapper">
            <iframe
                title="job board"
                src="https://www.paycomonline.net/v4/ats/web.php/jobs?clientkey=EC8F805338875AA87090A15CE68F1D46&fromClientSide=true" 
                className="iframe-full">
            </iframe>
        </div>
        // <div className='jobs-page'>
             

            /* <div className='jobs-banner'>
                <div className='container'>
                    <h1>Available Jobs</h1>
                    <h2>V3 Careers</h2>
                    <p>
                        V3 Electric is a fast-paced company with exponential growth.
                        We are an industry leader in solar technology, based in El
                        Dorado Hills, CA with multiple offices across the state. We
                        win the hearts of our customers because they can see that we
                        are fighting for them. In short, everything we do is
                        designed to give people more options, more freedom, more
                        choice.
                        <br/><br/>
                        This is our way of life.
                    </p>
                </div>
            </div>

            <div className='job-table'>
                <div className='filters'>
                    <div className='search-filter'>
                        <h3>Location</h3>
                        
                        {locations.map((loc) =>
                            <div>
                                <input key={loc} type="checkbox" id={loc} onChange={() => filterJobs(loc)} />
                                <label className='ps-2' htmlFor={loc}>{loc}</label>
                            </div>
                        )}
                    </div>

                    <div className='search-filter'>
                        <h3>Department</h3>
                        {departments.map((dep) =>
                            <div>
                                <input key={dep} type="checkbox" id={dep} onChange={() => filterJobs(dep)} />
                                <label className='ps-2' htmlFor={dep}>{dep}</label>
                            </div>
                        )}
                    </div>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th>Role</th>
                            <th>Location</th>
                            <th>Department</th>
                        </tr>
                    </thead>
                    <tbody>
                        {jobs?.map((job) =>
                            <tr key={job.id}>
                                <td className='fw-normal'><Link to={`/jobs/${job._id}`}>{job.role}</Link></td>
                                <td>{job.location}</td>
                                <td>{job.department}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div> */
        // </div>
    );
};

export default Jobs;